import type { Association, Group, Opportunity } from "@entities";

const manager = { id: "tour-mgr", name: "יעל כהן" };
const partner = { id: "tour-partner", name: "לב אחד פתח תקווה" };

function opportunity(partial: Record<string, unknown>): Opportunity {
  return {
    teams: [],
    reports: [],
    isReportRequired: false,
    isDeleted: false,
    isClosed: false,
    isFull: false,
    isOpportunityGroupParent: false,
    hasTime: true,
    hasStartTime: true,
    manager,
    partnerOrganization: partner,
    partnerOrganizationId: partner.id,
    progressStatus: { id: "tour-status", title: "פתוח", color: "#05204c", type: "MISSION", order: 1 },
    ...partial,
  } as unknown as Opportunity;
}

export const TOUR_OPPORTUNITY = opportunity({
  id: "tour-opp",
  title: "ביקור בית לקשיש בפתח תקווה",
  location: "פתח תקווה",
  startDate: new Date("2026-09-12T09:00:00"),
  endDate: new Date("2026-09-30T12:00:00"),
  amount: 8,
  participantsCount: 3,
  description:
    "ביקור בית אצל קשיש לבד בבית. שיחה, עזרה קלה בקניות, ונוכחות למשך כמה שעות.",
  comments: "עדיף בוקר. יש מדרגות לבניין, בלי מעלית.",
  createdAt: new Date("2026-09-01"),
  volunteerMode: "BOTH",
  callCenterInVolunteerPool: true,
  isGroup: true,
  callCenterUrgency: 4,
  callCenterDifficulty: 2,
  isLongTerm: true,
  associationRequested: {
    user: { name: "רחל מזרחי", phoneNumber: "0525136601" },
  },
});

export const TOUR_SEARCH_ROWS: Opportunity[] = [
  TOUR_OPPORTUNITY,
  opportunity({
    id: "tour-opp-2",
    title: "חלוקת מזון בגבעתיים",
    location: "גבעתיים",
    startDate: new Date("2026-09-18T16:00:00"),
    endDate: new Date("2026-09-18T19:00:00"),
    amount: 12,
    participantsCount: 5,
    volunteerMode: "INDIVIDUAL",
    isGroup: false,
    callCenterUrgency: 3,
    callCenterDifficulty: 1,
    associationRequested: {
      user: { name: "דוד פרץ", phoneNumber: "0525136602" },
    },
  }),
  opportunity({
    id: "tour-opp-3",
    title: "ביקורי בית לקבוצת נוער",
    location: "רמת גן",
    startDate: new Date("2026-09-20T09:00:00"),
    endDate: new Date("2026-10-20T12:00:00"),
    amount: 15,
    participantsCount: 8,
    volunteerMode: "GROUP",
    isGroup: true,
    callCenterUrgency: 5,
    callCenterDifficulty: 3,
    associationRequested: {
      user: { name: "מרים אביב", phoneNumber: "0525136603" },
    },
  }),
  opportunity({
    id: "tour-opp-4",
    title: "ליווי לקופת חולים בפתח תקווה",
    location: "פתח תקווה",
    startDate: new Date("2026-09-22T08:00:00"),
    endDate: new Date("2026-09-22T11:00:00"),
    amount: 2,
    participantsCount: 0,
    volunteerMode: "INDIVIDUAL",
    isGroup: false,
    callCenterUrgency: 2,
    callCenterDifficulty: 1,
  }),
];

export type TourVolunteerRow = Association & { distanceKm: number };

function volunteer(partial: Record<string, unknown> & { distanceKm: number }): TourVolunteerRow {
  return {
    activityStatus: "ACTIVE",
    communicationRecords: [],
    teams: [],
    roles: [],
    user: {
      skills: [],
      address: partial.address,
      ...((partial.user as object) ?? {}),
    },
    ...partial,
  } as unknown as TourVolunteerRow;
}

export const TOUR_VOLUNTEERS: TourVolunteerRow[] = [
  volunteer({
    id: "tour-rel-1",
    userId: "tour-user-1",
    distanceKm: 3,
    activityStatus: "ACTIVE",
    address: "פתח תקווה",
    user: {
      id: "tour-user-1",
      name: "מיכל אזולאי",
      phoneNumber: "0525136682",
      dateOfBirth: new Date("1992-03-14"),
      address: "פתח תקווה",
      email: "michal@example.com",
    },
  }),
  volunteer({
    id: "tour-rel-2",
    userId: "tour-user-2",
    distanceKm: 7,
    activityStatus: "ACTIVE",
    user: {
      id: "tour-user-2",
      name: "עומר שטרן",
      phoneNumber: "0525136683",
      dateOfBirth: new Date("1998-07-02"),
      address: "גבעתיים",
      email: "omer@example.com",
    },
  }),
  volunteer({
    id: "tour-rel-3",
    userId: "tour-user-3",
    distanceKm: 9,
    activityStatus: "NEW",
    user: {
      id: "tour-user-3",
      name: "הדס לוי",
      phoneNumber: "0525136684",
      dateOfBirth: new Date("1985-11-21"),
      address: "רמת גן",
      email: "hadas@example.com",
    },
  }),
];

function group(partial: Record<string, unknown>): Group {
  return {
    opportunities: [],
    comments: "",
    ...partial,
  } as unknown as Group;
}

export const TOUR_GROUPS: Group[] = [
  group({
    id: "tour-group-1",
    name: "קבוצת נוער פתח תקווה",
    size: 12,
    comments: "פנויים ביום שישי בבוקר.",
    preferredStartDate: new Date("2026-09-12"),
    preferredEndDate: new Date("2026-09-30"),
    admin: {
      name: "אורי ביטון",
      phoneNumber: "0525136690",
      email: "ori@example.com",
    },
  }),
  group({
    id: "tour-group-2",
    name: "סטודנטים רמת גן",
    size: 8,
    comments: "יש רכב לאחד המשתתפים.",
    preferredStartDate: new Date("2026-09-15"),
    preferredEndDate: new Date("2026-10-01"),
    admin: {
      name: "ליאורה חדד",
      phoneNumber: "0525136691",
      email: "liora@example.com",
    },
  }),
  group({
    id: "tour-group-3",
    name: "גימלאים גבעתיים",
    size: 6,
    comments: "מעדיפים פעילות קצרה אחרי הצהריים.",
    preferredStartDate: new Date("2026-09-18"),
    preferredEndDate: new Date("2026-09-25"),
    admin: {
      name: "משה אלון",
      phoneNumber: "0525136692",
      email: "moshe@example.com",
    },
  }),
];

export const TOUR_FAQ = [
  {
    id: "tour-faq-1",
    question: "איך משבצים קבוצה?",
    answer: "פותחים את כרטיס המשימה, נכנסים להוספת משתתפים, ובוחרים הוספת קבוצות.",
  },
  {
    id: "tour-faq-2",
    question: "מה עושים אם הטלפון לא נמצא?",
    answer: "שולחים קישור כללי למערכת, או עוברים לחיפוש לפי אזור.",
  },
];

export const TOUR_CHAT = [
  {
    id: "tour-chat-1",
    kind: "TEXT",
    body: "אם הקבוצה מאשרת, שבצו אותה מכרטיס המשימה.",
    createdAt: new Date("2026-10-03T09:10:00"),
    fromCoordinator: true,
  },
  {
    id: "tour-chat-2",
    kind: "DETAILS_CARD",
    body: "משימה: ביקור בית לקשיש בפתח תקווה",
    createdAt: new Date("2026-10-03T09:14:00"),
    fromCoordinator: false,
  },
];
